const HEADER_WORDS =
  /\b(?:inv(?:oice)?|bill|date|party|customer|buyer|name|gstin|taxable|amount|value|rate|gst%?|hsn|sac|qty|quantity|item|igst|cgst|sgst|total)\b/giu;

/** Rows pasted from a sheet: tab-separated lines, or a header row of column names above at least two rows. */
export function isPastedTable(raw: string): boolean {
  const lines = raw.split(/\r?\n/).filter((line) => line.trim());
  if (lines.length < 2) return false;
  if (lines.filter((line) => /\t|\|.*\|/u.test(line)).length >= 2) return true;
  const header = lines[0] ?? '';
  return lines.length >= 3 && !/\d{3}/u.test(header) && new Set(header.toLowerCase().match(HEADER_WORDS)).size >= 3;
}

/** Pasted sales use the same byte limit as private file uploads. */
export const MAX_PASTED_BYTES = 5 * 1024 * 1024;
